type Indices<L extends number, T extends number[] = []> = T['length'] extends L
  ? T[number]
  : Indices<L, [T['length'], ...T]>;

type LengthAtLeast<T extends readonly any[], L extends number> = Pick<Required<T>, Indices<L>>;

/**
 * Assert that an array has a particular length before accessing its values by index.
 * e.g. Without this, arr[0] may be undefined.
 * @param arr array to check the length of
 * @param len length to check for
 * @returns boolean
 */
export const hasLengthAtLeast = <T extends readonly any[], L extends number>(
  arr: T,
  len: L
): arr is T & LengthAtLeast<T, L> => {
  return arr.length >= len;
};
